globalThis.cameraModels = {
  criteria: {
    anchorFlagGnYwReq: 0.995,
    anchorFlagYwRdReq: 0.99,
    heightFlagGnYwReq: 0.995,
    heightFlagYwRdReq: 0.99,
    numAncsReq: 4,
    stickAngleReq: 0.268, //this is currently set at the tan(15)
    anchorFitReq: 0.005, //that is .5 percent of the total height (that is 3" at 50')
    alignmentFitGnYwReq: 0.995, //that is an average anchor mV error of 0.000025 (equiv to a 0.98 in PMP with Crain SVR 17' stick setup: 0.98 = 1 - sqrt(0.000025*16), the 0.995 = 1 - sqrt(0.000025))
    alignmentFitYwRdReq: 0.98, //that is an average anchor mV error of 0.000400 (equiv to a 0.92 in PMP with Crain SVR 17' stick setup: 0.92 = 1 - sqrt(0.000400*16), the 0.980 = 1 - sqrt(0.000400))
    anchorGapStdDevReq: 0.25, //testing shows this is probably between 0.2 and 0.3
    anchorGapsGnYwReq: 0.25, //25% - an educated guess - need more test results
    anchorGapsYwRdReq: 0.5 //50% - an initial guess - need test results
  },
  extrapolationCriteria: {
    targetDiameter: 0.25,
    targetError: 0.09375,
    horizontalCenter: 0.33,
    ninetyFiveRatio: {
      4: 0.65,
      5: 0.65,
      6: 0.65,
      7: 0.65
    }
  },
  cameraModels: [
    {
      name: 'CANON EOS REBEL T3I',
      lens: 'EF28-135mm f/3.5-5.6 IS USM',
      height: 5184,
      width: 3456,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      focalLengths: [
        28, 30, 33, 35, 38, 41, 44, 47, 50, 53, 56, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 109, 112, 115, 117, 120, 122, 125, 127, 130,
        132, 135
      ],
      type: 'txiALL'
    },
    {
      name: 'CANON EOS REBEL T4I',
      lens: 'EF28-135mm f/3.5-5.6 IS USM',
      height: 5184,
      width: 3456,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      focalLengths: [
        28, 30, 33, 35, 38, 41, 44, 47, 50, 53, 56, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 109, 112, 115, 117, 120, 122, 125, 127, 130,
        132, 135
      ],
      type: 'txiALL'
    },
    {
      name: 'CANON EOS REBEL T5I',
      lens: 'EF28-135mm f/3.5-5.6 IS USM',
      height: 5184,
      width: 3456,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      focalLengths: [
        28, 30, 33, 35, 38, 41, 44, 47, 50, 53, 56, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 109, 112, 115, 117, 120, 122, 125, 127, 130,
        132, 135
      ],
      type: 'txiALL'
    },
    {
      name: 'CANON EOS REBEL T5I',
      lens: 'EF28-135mm f/3.5-5.6 IS USM',
      height: 3456,
      width: 2304,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      focalLengths: [
        28, 30, 33, 35, 38, 41, 44, 47, 50, 53, 56, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 109, 112, 115, 117, 120, 122, 125, 127, 130,
        132, 135
      ],
      type: 'txiALL'
    },
    {
      name: 'CANON EOS REBEL T5',
      lens: 'EF28-135mm f/3.5-5.6 IS USM',
      height: 5184,
      width: 3456,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      focalLengths: [
        28, 30, 33, 35, 38, 41, 44, 47, 50, 53, 56, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 109, 112, 115, 117, 120, 122, 125, 127, 130,
        132, 135
      ],
      type: 'txiALL'
    },
    {
      name: 'CANON EOS REBEL T6I',
      lens: 'EF28-135mm f/3.5-5.6 IS USM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      focalLengths: [
        28, 30, 33, 35, 38, 41, 44, 47, 50, 53, 56, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 109, 112, 115, 117, 120, 122, 125, 127, 130,
        132, 135
      ],
      type: 'txiALL',
      distortion_correction: false
    },
    {
      name: 'CANON EOS REBEL T6S',
      lens: 'EF28-135mm f/3.5-5.6 IS USM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      focalLengths: [
        28, 30, 33, 35, 38, 41, 44, 47, 50, 53, 56, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 109, 112, 115, 117, 120, 122, 125, 127, 130,
        132, 135
      ],
      type: 'txiALL'
    },
    {
      name: 'CANON EOS REBEL T6',
      lens: 'EF28-135mm f/3.5-5.6 IS USM',
      height: 5184,
      width: 3456,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      focalLengths: [
        28, 30, 33, 35, 38, 41, 44, 47, 50, 53, 56, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 109, 112, 115, 117, 120, 122, 125, 127, 130,
        132, 135
      ],
      type: 'txiALL'
    },
    {
      name: 'CANON EOS REBEL T7I',
      lens: 'EF28-135mm f/3.5-5.6 IS USM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      focalLengths: [
        28, 30, 33, 35, 38, 41, 44, 47, 50, 53, 56, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 109, 112, 115, 117, 120, 122, 125, 127, 130,
        132, 135
      ],
      type: 'txiALL',
      distortion_correction: false
    },
    {
      name: 'CANON EOS REBEL SL2',
      lens: 'EF28-135mm f/3.5-5.6 IS USM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      focalLengths: [
        28, 30, 33, 35, 38, 41, 44, 47, 50, 53, 56, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 109, 112, 115, 117, 120, 122, 125, 127, 130,
        132, 135
      ],
      type: 'txiALL',
      distortion_correction: false
    },
    {
      name: 'CANON EOS REBEL SL3',
      lens: 'EF28-135mm f/3.5-5.6 IS USM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      focalLengths: [
        28, 30, 33, 35, 38, 41, 44, 47, 50, 53, 56, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 109, 112, 115, 117, 120, 122, 125, 127, 130,
        132, 135
      ],
      type: 'txiALL',
      distortion_correction: false
    },
    {
      name: 'CANON EOS 250D',
      lens: 'EF28-135mm f/3.5-5.6 IS USM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      focalLengths: [
        28, 30, 33, 35, 38, 41, 44, 47, 50, 53, 56, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 109, 112, 115, 117, 120, 122, 125, 127, 130,
        132, 135
      ],
      type: 'txiALL',
      distortion_correction: false
    },
    {
      name: 'Canon EOS 1200D',
      lens: 'EF28-135mm f/3.5-5.6 IS USM',
      height: 5184,
      width: 3456,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      focalLengths: [
        28, 30, 33, 35, 38, 41, 44, 47, 50, 53, 56, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 109, 112, 115, 117, 120, 122, 125, 127, 130,
        132, 135
      ],
      type: 'txiALL'
    },
    {
      name: 'PENTAX OPTIO WG-2 GPS',
      lens: 'ALL',
      height: 4608,
      width: 2592,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg2'
    },
    {
      name: 'PENTAX OPTIO WG-2 GPS',
      lens: 'ALL',
      height: 4608,
      width: 3456,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg2'
    },
    {
      name: 'PENTAX OPTIO WG-2',
      lens: 'ALL',
      height: 4608,
      width: 2592,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg2'
    },
    {
      name: 'PENTAX OPTIO WG-2',
      lens: 'ALL',
      height: 3456,
      width: 3456,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg2'
    },
    {
      name: 'PENTAX OPTIO WG-2',
      lens: 'ALL',
      height: 4608,
      width: 3456,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg2'
    },
    {
      name: 'RICOH WG-30W',
      lens: 'ALL',
      height: 4608,
      width: 2592,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg30'
    },
    {
      name: 'RICOH WG-30W',
      lens: 'ALL',
      height: 4608,
      width: 3456,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg30'
    },
    {
      name: 'RICOH WG-50',
      lens: 'ALL',
      height: 4608,
      width: 2592,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg50'
    },
    {
      name: 'RICOH WG-50',
      lens: 'ALL',
      height: 4608,
      width: 3456,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg50'
    },
    {
      name: 'RICOH WG-50',
      lens: 'ALL',
      height: 3072,
      width: 2304,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg50'
    },
    {
      name: 'RICOH WG-50',
      lens: 'ALL',
      height: 3456,
      width: 3456,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg50'
    },
    {
      name: 'RICOH WG-60',
      lens: 'ALL',
      height: 4608,
      width: 2592,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg50'
    },
    {
      name: 'RICOH WG-60',
      lens: 'ALL',
      height: 4608,
      width: 3456,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg50'
    },
    {
      name: 'RICOH WG-60',
      lens: 'ALL',
      height: 3072,
      width: 2304,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg50'
    },
    {
      name: 'RICOH WG-60',
      lens: 'ALL',
      height: 3456,
      width: 3456,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg50'
    },
    {
      name: 'RICOH WG-70',
      lens: 'ALL',
      height: 4608,
      width: 2592,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg50'
    },
    {
      name: 'RICOH WG-70',
      lens: 'ALL',
      height: 4608,
      width: 3456,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg50'
    },
    {
      name: 'RICOH WG-70',
      lens: 'ALL',
      height: 3072,
      width: 2304,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg50'
    },
    {
      name: 'RICOH WG-70',
      lens: 'ALL',
      height: 3456,
      width: 3456,
      focalLengths: [5, 6.1, 7.5, 9.1, 11.1, 13.7, 16.7, 20.6, 25],
      type: 'wg50'
    },
    {
      name: 'PENTAX WG-3',
      lens: 'ALL',
      height: 4608,
      width: 2592,
      focalLengths: [4.5, 4.8, 5.5, 5.9, 6.4, 6.9, 7.3, 7.9, 8.4, 9, 9.6, 10.3, 11, 11.8, 12.6, 13.5, 14.4, 15.4, 16.5, 18],
      type: 'wg3'
    },
    {
      name: 'PENTAX WG-3 GPS',
      lens: 'ALL',
      height: 4608,
      width: 2592,
      focalLengths: [4.5, 4.8, 5.5, 5.9, 6.4, 6.9, 7.3, 7.9, 8.4, 9, 9.6, 10.3, 11, 11.8, 12.6, 13.5, 14.4, 15.4, 16.5, 18],
      type: 'wg3'
    },
    {
      name: 'RICOH WG-4 GPS',
      lens: 'ALL',
      height: 4608,
      width: 3456,
      focalLengths: [4.5, 4.8, 5.5, 5.9, 6.4, 6.9, 7.3, 7.9, 8.4, 9, 9.6, 10.3, 11, 11.8, 12.6, 13.5, 14.4, 15.4, 16.5, 18],
      type: 'wgAfter3'
    },
    {
      name: 'RICOH WG-4 GPS',
      lens: 'ALL',
      height: 3072,
      width: 2304,
      focalLengths: [4.5, 4.8, 5.5, 5.9, 6.4, 6.9, 7.3, 7.9, 8.4, 9, 9.6, 10.3, 11, 11.8, 12.6, 13.5, 14.4, 15.4, 16.5, 18],
      type: 'wgAfter3'
    },
    {
      name: 'RICOH WG-4 GPS',
      lens: 'ALL',
      height: 4608,
      width: 2592,
      focalLengths: [3.6, 4.5, 4.8, 5.5, 5.9, 6.4, 6.9, 7.3, 7.9, 8.4, 9, 9.6, 10.3, 11, 11.8, 12.6, 13.5, 14.4, 15.4, 16.5, 18],
      type: 'wgAfter3'
    },
    {
      name: 'RICOH WG-5 GPS',
      lens: 'ALL',
      height: 4608,
      width: 2592,
      focalLengths: [3.6, 4.5, 4.8, 5.5, 5.9, 6.4, 6.9, 7.3, 7.9, 8.4, 9, 9.6, 10.3, 11, 11.8, 12.6, 13.5, 14.4, 15.4, 16.5, 18],
      type: 'wgAfter3'
    },
    {
      name: 'RICOH WG-5 GPS',
      lens: 'ALL',
      height: 4608,
      width: 3456,
      focalLengths: [3.6, 4.5, 4.8, 5.5, 5.9, 6.4, 6.9, 7.3, 7.9, 8.4, 9, 9.6, 10.3, 11, 11.8, 12.6, 13.5, 14.4, 15.4, 16.5, 18],
      type: 'wgAfter3'
    },
    {
      name: 'RICOH WG-4',
      lens: 'ALL',
      height: 4608,
      width: 3456,
      focalLengths: [4.5, 4.8, 5.5, 5.9, 6.4, 6.9, 7.3, 7.9, 8.4, 9, 9.6, 10.3, 11, 11.8, 12.6, 13.5, 14.4, 15.4, 16.5, 18],
      type: 'wgAfter3'
    },
    {
      name: 'RICOH WG-5',
      lens: 'ALL',
      height: 4608,
      width: 2592,
      focalLengths: [4.5, 4.8, 5.5, 5.9, 6.4, 6.9, 7.3, 7.9, 8.4, 9, 9.6, 10.3, 11, 11.8, 12.6, 13.5, 14.4, 15.4, 16.5, 18],
      type: 'wgAfter3'
    },
    {
      name: 'RICOH WG-5',
      lens: 'ALL',
      height: 4608,
      width: 3456,
      focalLengths: [4.5, 4.8, 5.5, 5.9, 6.4, 6.9, 7.3, 7.9, 8.4, 9, 9.6, 10.3, 11, 11.8, 12.6, 13.5, 14.4, 15.4, 16.5, 18],
      type: 'wgAfter3'
    },
    // 	{name:'CANON EOS REBEL T3I', lens:'EF-S18-55mm f/3.5-5.6 IS II', height:5184, width:3456, focalLengths:[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55], type:'txi_kit_lens'},
    // 	{name:'CANON EOS REBEL T4I', lens:'EF-S18-55mm f/3.5-5.6 IS II', height:5184, width:3456, focalLengths:[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55], type:'txi_kit_lens'},
    // 	{name:'CANON EOS REBEL T5I', lens:'EF-S18-55mm f/3.5-5.6 IS II', height:5184, width:3456, focalLengths:[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55], type:'txi_kit_lens'},
    // 	{name:'CANON EOS REBEL T5', lens:'EF-S18-55mm f/3.5-5.6 IS II', height:5184, width:3456, focalLengths:[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55], type:'txi_kit_lens'},
    // 	{name:'CANON EOS REBEL T6I', lens:'EF-S18-55mm f/3.5-5.6 IS II', height:6000, width:4000, focalLengths:[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55], type:'txi_kit_lens'},
    // 	{name:'CANON EOS REBEL T6', lens:'EF-S18-55mm f/3.5-5.6 IS II', height:5184, width:3456, focalLengths:[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55], type:'txi_kit_lens'},
    // 	{name:'CANON EOS REBEL T3I', lens:'EF-S18-55mm f/3.5-5.6 IS STM', height:5184, width:3456, focalLengths:[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55], type:'txi_kit_lens'},
    // 	{name:'CANON EOS REBEL T4I', lens:'EF-S18-55mm f/3.5-5.6 IS STM', height:5184, width:3456, focalLengths:[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55], type:'txi_kit_lens'},
    // {name:'CANON EOS REBEL T5I', lens:'EF-S18-55mm f/3.5-5.6 IS STM', height:5184, width:3456, focalLengths:[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55], type:'txi_kit_lens'},
    // 	{name:'CANON EOS REBEL T5', lens:'EF-S18-55mm f/3.5-5.6 IS STM', height:5184, width:3456, focalLengths:[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55], type:'txi_kit_lens'},
    // 	{name:'CANON EOS REBEL T6I', lens:'EF-S18-55mm f/3.5-5.6 IS STM', height:6000, width:4000, focalLengths:[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55], type:'txi_kit_lens'},
    // 	{name:'CANON EOS REBEL T7I', lens:'EF-S18-55mm f/3.5-5.6 IS STM', height:6000, width:4000, focalLengths:[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55], type:'txi_kit_lens', distortion_correction: false},
    // 	{name:'CANON EOS REBEL SL2', lens:'EF-S18-55mm f/3.5-5.6 IS STM', height:6000, width:4000, focalLengths:[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55], type:'txi_kit_lens', distortion_correction: false},
    // 	{name:'CANON EOS REBEL SL3', lens:'EF-S18-55mm f/4-5.6 IS STM', height:6000, width:4000, focalLengths:[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55], type:'txi_kit_lens', distortion_correction: false},
    //  {name:'CANON EOS REBEL SL3', lens:'EF-S18-55mm f/4-5.6 IS STM', height:6000, width:4000, focalLengths:[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55], type:'flat', distortion_correction: false, required_attributes:{image_software:"DxO PhotoLab 4.2"}},
    // 	{name:'Canon EOS 1200D', lens:'EF-S18-55mm f/3.5-5.6 IS II', height:5184, width:3456, focalLengths:[18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55], type:'txi_kit_lens'},
    // { name: 'CANON EOS REBEL T5I', lens: 'EF-S24mm f/2.8 STM', height: 5184, width: 3456, focalLengths: [24], type: 'canon_prime_lens' },
    // { name: 'HERO4 SILVER', lens: 'ALL', height: 4000, width: 3000, focalLengths: [3], type: 'gopro_hero4' },
    // { name: 'WB350F/WB351F/WB352F', lens: 'ALL', height: 4608, width: 3456, focalLengths: [4.1, 5, 6.2], type: 'samsung_WB35xF' },
    // { name: 'SM-T210R', lens: 'ALL', height: 2048, width: 1536, focalLengths: [2.79], type: 'samsung_WB35xF' },
    {
      name: 'TG-4',
      lens: 'ALL',
      height: 4608,
      width: 3456,
      focalLengths: [
        4.5, 5.14, 5.5, 5.87, 6.42, 6.86, 7.34, 7.86, 8.41, 8.99, 9.61, 10.29, 11.01, 11.78, 12.6, 13.47, 14.41, 15.41, 16.48, 18
      ],
      type: 'olympusTG4'
    },
    {
      name: 'TG-5',
      lens: 'ALL',
      height: 4000,
      width: 3000,
      focalLengths: [
        4.5, 5.14, 5.5, 5.87, 6.42, 6.86, 7.34, 7.86, 8.41, 8.99, 9.61, 10.29, 11.01, 11.78, 12.6, 13.47, 14.41, 15.41, 16.48, 18
      ],
      type: 'olympusTG4'
    },
    // {
    //   name: 'IPAD MINI 4',
    //   lens: 'iPad mini 4 back camera 3.3mm f/2.4',
    //   height: 3264,
    //   width: 2448,
    //   focalLengths: [3.3],
    //   type: 'iPad_mini_4'
    // },
    // { name: 'IPHONE 5S', lens: 'iPhone 5s back camera 4.15mm f/2.2', height: 3264, width: 2448, focalLengths: [4.15], type: 'iPhone_5s' },
    //{name:'IPHONE 4S', lens:'ALL', height:3264, width:2448, focalLengths: [4.28], type:'iphone4s'},
    //{name:'NEXUS 4', lens:'ALL', height:3264, width:2448, focalLengths: [4.6], type:'nexus4'}
    // { name: 'SM-T830', lens: 'ALL', height: 4032, width: 3024, focalLengths: [3.6], type: 'galaxy_tab_s4' }, //Galaxy Tab S4
    // { name: 'SM-T837V', lens: 'ALL', height: 4032, width: 3024, focalLengths: [3.6], type: 'galaxy_tab_s4' }, //Galaxy Tab S4 LTE
    {
      name: 'CANON EOS M50',
      lens: 'EF-M18-150mm f/3.5-6.3 IS STM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      type: 'flat'
    },
    {
      name: 'CANON EOS M50m2',
      lens: 'EF-M18-150mm f/3.5-6.3 IS STM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      type: 'flat'
    },
    // {
    //     name:'CANON EOS M50',
    //     lens:'EF-M18-150mm f/3.5-6.3 IS STM',
    //     height:6000,
    //     width:4000,
    //     distortion_correction: false,
    //     focalLengths: [18, 21, 22, 24, 26, 28, 29, 30, 31, 32, 34, 35, 37, 39, 40, 41, 43, 44, 45, 47, 48, 50, 52, 54, 56, 57, 59, 60 , 62, 64, 68, 70, 74, 76, 79, 81, 84, 86, 89, 92, 95, 100, 105, 111, 115, 118, 125, 129, 132, 135, 138, 141, 150],
    //     type:'M50_18_155'
    // },
    {
      name: 'CANON EOS REBEL SL2',
      lens: 'EF-S18-55mm f/3.5-5.6 IS II',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      type: 'flat'
    },
    {
      name: 'CANON EOS REBEL SL2',
      lens: 'EF-S18-55mm f/4-5.6 IS STM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      type: 'flat'
    },
    {
      name: 'CANON EOS 200D',
      lens: 'EF-S18-55mm f/4-5.6 IS STM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      type: 'flat'
    },
    {
      name: 'CANON EOS REBEL SL2',
      lens: 'EF28-135mm f/3.5-5.6 IS USM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      type: 'flat'
    },
    {
      name: 'CANON EOS REBEL SL2',
      lens: 'EF-S18-55mm f/3.5-5.6 III',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      type: 'flat'
    },
    {
      name: 'CANON EOS REBEL SL3',
      lens: 'EF-S18-55mm f/3.5-5.6 IS II',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      type: 'flat'
    },
    {
      name: 'CANON EOS REBEL SL3',
      lens: 'EF-S18-55mm f/4-5.6 IS STM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      type: 'flat'
    },
    {
      name: 'CANON EOS REBEL SL3',
      lens: 'EF28-135mm f/3.5-5.6 IS USM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      type: 'flat'
    },
    {
      name: 'CANON EOS REBEL SL3',
      lens: 'EF-S18-55mm f/3.5-5.6 III',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      type: 'flat'
    },

    // { name: 'SM-T830', lens: 'ALL', height: 4032, width: 3024, focalLengths: [3.6], type: 'galaxy_tab_s4' }, //Galaxy Tab S4
    // { name: 'SM-T837V', lens: 'ALL', height: 4032, width: 3024, focalLengths: [3.6], type: 'galaxy_tab_s4' }, //Galaxy Tab S4 LTE

    {
      name: 'CANON EOS 250D',
      lens: 'EF-S18-55mm f/3.5-5.6 IS II',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      type: 'flat'
    },
    {
      name: 'CANON EOS 250D',
      lens: 'EF-S18-55mm f/4-5.6 IS STM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      type: 'flat'
    },
    {
      name: 'CANON EOS 250D',
      lens: 'EF28-135mm f/3.5-5.6 IS USM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      type: 'flat'
    },
    {
      name: 'CANON EOS 250D',
      lens: 'EF-S18-55mm f/3.5-5.6 III',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      type: 'flat'
    },
    {
      name: 'Canon EOS R100',
      lens: 'RF24-105mm F4-7.1 IS STM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      focalLengths: [
        24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56,
        57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89,
        90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105
      ],
      type: 'RF24_105'
    },
    {
      name: 'Canon EOS R100',
      lens: 'RF24-105mm F4 L IS USM',
      height: 6000,
      width: 4000,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      focalLengths: [
        24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56,
        57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89,
        90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105
      ],
      type: 'RF24_105L'
    },
    {
      // Reuses the R100's RF24_105 lens model, which is resolution-independent and applies to any APS-C body.
      // Gated to internal use until it has been validated on this body.
      name: 'Canon EOS R7',
      lens: 'RF24-105mm F4-7.1 IS STM',
      height: 6960,
      width: 4640,
      sensorWidth: 22.3,
      sensorHeight: 14.9,
      distortion_correction: true,
      focalLengths: [
        24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56,
        57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89,
        90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105
      ],
      type: 'RF24_105',
      feature_flag: 'canon_r7_calibration'
    }
  ],

  cameraModelData: {
    // cameras
    // canon_prime_lens: {
    //   config: {
    //     stickMultiplierWarning: 3.4,
    //     stickMultiplierError: 4
    //   },
    //   24: {
    //     aMin: 0.0049,
    //     aMid: 0.0049,
    //     aMax: 0.0049,
    //     bMin: -0.01419,
    //     bMid: -0.01419,
    //     bMax: -0.01419,
    //     cMin: -0.00212,
    //     cMid: -0.00212,
    //     cMax: -0.00212
    //   }
    // },
    txi_kit_lens: {
      config: {
        stickMultiplierWarning: 3.4,
        stickMultiplierError: 4
      },
      18: { bMin: -0.0191, bMid: -0.0163, bMax: -0.0142 },
      19: { bMin: -0.0164, bMid: -0.0143, bMax: -0.0122 },
      20: { bMin: -0.0136, bMid: -0.0122, bMax: -0.0101 },
      21: { bMin: -0.0125, bMid: -0.011, bMax: -0.0091 },
      22: { bMin: -0.0113, bMid: -0.0098, bMax: -0.008 },
      23: { bMin: -0.0102, bMid: -0.0085, bMax: -0.007 },
      24: { bMin: -0.009, bMid: -0.0073, bMax: -0.0059 },
      25: { bMin: -0.0079, bMid: -0.0064, bMax: -0.0051 },
      26: { bMin: -0.0069, bMid: -0.0055, bMax: -0.0044 },
      27: { bMin: -0.0058, bMid: -0.0047, bMax: -0.0036 },
      28: { bMin: -0.0048, bMid: -0.0038, bMax: -0.0029 },
      29: { bMin: -0.0037, bMid: -0.0029, bMax: -0.0021 },
      30: { bMin: -0.0033, bMid: -0.0025, bMax: -0.0019 },
      31: { bMin: -0.0029, bMid: -0.0021, bMax: -0.0016 },
      32: { bMin: -0.0025, bMid: -0.0018, bMax: -0.0014 },
      33: { bMin: -0.002, bMid: -0.0014, bMax: -0.0011 },
      34: { bMin: -0.0016, bMid: -0.001, bMax: -0.0009 },
      35: { bMin: -0.0012, bMid: -0.0006, bMax: -0.0006 },
      36: { bMin: -0.001, bMid: -0.0004, bMax: -0.0004 },
      37: { bMin: -0.0008, bMid: -0.0002, bMax: -0.0002 },
      38: { bMin: -0.0006, bMid: -0.0001, bMax: -0.0001 },
      39: { bMin: -0.0004, bMid: 0.0001, bMax: 0.0001 },
      40: { bMin: -0.0003, bMid: 0.0003, bMax: 0.0003 },
      41: { bMin: -0.0001, bMid: 0.0005, bMax: 0.0005 },
      42: { bMin: 0.0001, bMid: 0.0007, bMax: 0.0007 },
      43: { bMin: 0.0003, bMid: 0.0008, bMax: 0.0008 },
      44: { bMin: 0.0005, bMid: 0.001, bMax: 0.001 },
      45: { bMin: 0.0007, bMid: 0.0012, bMax: 0.0012 },
      46: { bMin: 0.0007, bMid: 0.0012, bMax: 0.0012 },
      47: { bMin: 0.0008, bMid: 0.0012, bMax: 0.0012 },
      48: { bMin: 0.0008, bMid: 0.0013, bMax: 0.0013 },
      49: { bMin: 0.0008, bMid: 0.0013, bMax: 0.0013 },
      50: { bMin: 0.0009, bMid: 0.0013, bMax: 0.0013 },
      51: { bMin: 0.0009, bMid: 0.0013, bMax: 0.0013 },
      52: { bMin: 0.0009, bMid: 0.0013, bMax: 0.0013 },
      53: { bMin: 0.0009, bMid: 0.0014, bMax: 0.0014 },
      54: { bMin: 0.001, bMid: 0.0014, bMax: 0.0014 },
      55: { bMin: 0.001, bMid: 0.0014, bMax: 0.0014 }
    },
    txiALL: {
      config: {
        stickMultiplierWarning: 3.4,
        stickMultiplierError: 4
      },
      28: { bMin: -0.010875, bMid: -0.00975, bMax: -0.008625 },
      30: { bMin: -0.008625, bMid: -0.0075, bMax: -0.006375 },
      33: { bMin: -0.006375, bMid: -0.00525, bMax: -0.004625 },
      35: { bMin: -0.004625, bMid: -0.004, bMax: -0.00325 },
      38: { bMin: -0.00325, bMid: -0.0025, bMax: -0.002 },
      41: { bMin: -0.002, bMid: -0.0015, bMax: -0.001 },
      44: { bMin: -0.001, bMid: -0.0005, bMax: 0 },
      47: { bMin: 0, bMid: 0.0005, bMax: 0.000625 },
      50: { bMin: 0.000625, bMid: 0.00075, bMax: 0.000875 },
      53: { bMin: 0.000875, bMid: 0.001, bMax: 0.0015 },
      56: { bMin: 0.0015, bMid: 0.002, bMax: 0.002125 },
      60: { bMin: 0.002125, bMid: 0.00225, bMax: 0.00225 },
      65: { bMin: 0.00225, bMid: 0.00225, bMax: 0.00225 },
      70: { bMin: 0.00225, bMid: 0.00225, bMax: 0.00225 },
      75: { bMin: 0.00225, bMid: 0.00225, bMax: 0.00225 },
      80: { bMin: 0.00225, bMid: 0.00225, bMax: 0.00225 },
      85: { bMin: 0.00225, bMid: 0.00225, bMax: 0.00225 },
      90: { bMin: 0.00225, bMid: 0.00225, bMax: 0.00225 },
      95: { bMin: 0.00225, bMid: 0.00225, bMax: 0.002375 },
      100: { bMin: 0.002375, bMid: 0.0025, bMax: 0.0025 },
      105: { bMin: 0.0025, bMid: 0.0025, bMax: 0.0025 },
      109: { bMin: 0.0025, bMid: 0.0025, bMax: 0.0025 },
      112: { bMin: 0.0025, bMid: 0.0025, bMax: 0.0025 },
      115: { bMin: 0.0025, bMid: 0.0025, bMax: 0.0025 },
      117: { bMin: 0.0025, bMid: 0.0025, bMax: 0.0025 },
      120: { bMin: 0.0025, bMid: 0.0025, bMax: 0.0025 },
      122: { bMin: 0.0025, bMid: 0.0025, bMax: 0.0025 },
      125: { bMin: 0.0025, bMid: 0.0025, bMax: 0.0025 },
      127: { bMin: 0.0025, bMid: 0.0025, bMax: 0.0025 },
      130: { bMin: 0.0025, bMid: 0.0025, bMax: 0.0025 },
      132: { bMin: 0.0025, bMid: 0.0025, bMax: 0.0025 },
      135: { bMin: 0.0025, bMid: 0.0025, bMax: 0.0025 }
    },
    wg2: {
      config: {
        stickMultiplierWarning: 3.4,
        stickMultiplierError: 4
      },
      5: { bMin: 0, bMid: 0, bMax: 0 },
      6.1: { bMin: 0, bMid: 0, bMax: 0 },
      7.5: { bMin: 0, bMid: 0, bMax: 0 },
      9.1: { bMin: 0, bMid: 0, bMax: 0 },
      11.1: { bMin: 0, bMid: 0, bMax: 0 },
      13.7: { bMin: 0, bMid: 0, bMax: 0 },
      16.7: { bMin: 0, bMid: 0, bMax: 0 },
      20.6: { bMin: 0, bMid: 0, bMax: 0 },
      25: { bMin: 0, bMid: 0, bMax: 0 }
    },
    wg3: {
      config: {
        stickMultiplierWarning: 3.4,
        stickMultiplierError: 4
      },
      4.5: { bMin: 0.002, bMid: 0.002, bMax: 0.002 },
      4.8: { bMin: 0.0018, bMid: 0.0018, bMax: 0.0018 },
      5.5: { bMin: 0.0013, bMid: 0.0013, bMax: 0.0013 },
      5.9: { bMin: 0.001, bMid: 0.001, bMax: 0.001 },
      6.4: { bMin: 0.0012, bMid: 0.0012, bMax: 0.0012 },
      6.9: { bMin: 0.0004, bMid: 0.0004, bMax: 0.0004 },
      7.3: { bMin: 0.0003, bMid: 0.0003, bMax: 0.0003 },
      7.9: { bMin: 0.0001, bMid: 0.0001, bMax: 0.0001 },
      8.4: { bMin: -0.0001, bMid: -0.0001, bMax: -0.0001 },
      9: { bMin: -0.0006, bMid: -0.0006, bMax: -0.0006 },
      9.6: { bMin: 0.0003, bMid: 0.0003, bMax: 0.0003 },
      10.3: { bMin: -0.0006, bMid: -0.0006, bMax: -0.0006 },
      11: { bMin: -0.0008, bMid: -0.0008, bMax: -0.0008 },
      11.8: { bMin: -0.0021, bMid: -0.0021, bMax: -0.0021 },
      12.6: { bMin: -0.0018, bMid: -0.0018, bMax: -0.0018 },
      13.5: { bMin: -0.0013, bMid: -0.0013, bMax: -0.0013 },
      14.4: { bMin: -0.0043, bMid: -0.0043, bMax: -0.0043 },
      15.4: { bMin: -0.001, bMid: -0.001, bMax: -0.001 },
      16.5: { bMin: -0.001, bMid: -0.001, bMax: -0.001 },
      18: { bMin: -0.0016, bMid: -0.0016, bMax: -0.0016 }
    },
    wgAfter3: {
      config: {
        stickMultiplierWarning: 3.4,
        stickMultiplierError: 4
      },
      4.5: { bMin: 0.0031, bMid: 0.0031, bMax: 0.0031 },
      4.8: { bMin: 0.0032, bMid: 0.0032, bMax: 0.0032 },
      5.5: { bMin: 0.0016, bMid: 0.0016, bMax: 0.0016 },
      5.9: { bMin: 0.0012, bMid: 0.0012, bMax: 0.0012 },
      6.4: { bMin: 0.0007, bMid: 0.0007, bMax: 0.0007 },
      6.9: { bMin: -0.0002, bMid: -0.0002, bMax: -0.0002 },
      7.3: { bMin: 0.0002, bMid: 0.0002, bMax: 0.0002 },
      7.9: { bMin: 0.0002, bMid: 0.0002, bMax: 0.0002 },
      8.4: { bMin: -0.0002, bMid: -0.0002, bMax: -0.0002 },
      9: { bMin: -0.0001, bMid: -0.0001, bMax: -0.0001 },
      9.6: { bMin: -0.0003, bMid: -0.0003, bMax: -0.0003 },
      10.3: { bMin: -0.0001, bMid: -0.0001, bMax: -0.0001 },
      11: { bMin: -0.0004, bMid: -0.0004, bMax: -0.0004 },
      11.8: { bMin: -0.0004, bMid: -0.0004, bMax: -0.0004 },
      12.6: { bMin: -0.0007, bMid: -0.0007, bMax: -0.0007 },
      13.5: { bMin: -0.0009, bMid: -0.0009, bMax: -0.0009 },
      14.4: { bMin: -0.0013, bMid: -0.0013, bMax: -0.0013 },
      15.4: { bMin: -0.0012, bMid: -0.0012, bMax: -0.0012 },
      16.5: { bMin: -0.0015, bMid: -0.0015, bMax: -0.0015 },
      18: { bMin: -0.0011, bMid: -0.0011, bMax: -0.0011 }
    },
    wg30: {
      config: {
        stickMultiplierWarning: 3.4,
        stickMultiplierError: 4
      },
      5: { bMin: 0, bMid: -0.00048, bMax: 0 },
      6.1: { bMin: 0, bMid: 0, bMax: 0 },
      7.5: { bMin: 0, bMid: 0, bMax: 0 },
      9.1: { bMin: 0, bMid: 0, bMax: 0 },
      11.1: { bMin: 0, bMid: 0, bMax: 0 },
      13.7: { bMin: 0, bMid: 0, bMax: 0 },
      16.7: { bMin: 0, bMid: 0, bMax: 0 },
      20.6: { bMin: 0, bMid: 0, bMax: 0 },
      25: { bMin: 0, bMid: 0, bMax: 0 }
    },
    wg50: {
      config: {
        stickMultiplierWarning: 3.4,
        stickMultiplierError: 4
      },
      5: { bMin: 0, bMid: 0, bMax: 0 },
      6.1: { bMin: 0, bMid: 0, bMax: 0 },
      7.5: { bMin: 0, bMid: 0, bMax: 0 },
      9.1: { bMin: 0, bMid: 0, bMax: 0 },
      11.1: { bMin: 0, bMid: 0, bMax: 0 },
      13.7: { bMin: 0, bMid: 0, bMax: 0 },
      16.7: { bMin: 0, bMid: 0, bMax: 0 },
      20.6: { bMin: 0, bMid: 0, bMax: 0 },
      25: { bMin: 0, bMid: 0, bMax: 0 }
    },
    // gopro_hero4: {
    //   config: {
    //     stickMultiplierWarning: 3.4,
    //     stickMultiplierError: 4
    //   },
    //   3: { aMin: -0.07, aMid: -0.07, aMax: -0.07, bMin: -0.12, bMid: -0.12, bMax: -0.12, cMin: -0.01, cMid: -0.01, cMax: -0.01 }
    // },
    // samsung_WB35xF: {
    //   config: {
    //     stickMultiplierWarning: 3.4,
    //     stickMultiplierError: 4
    //   },
    //   2.79: { bMin: 0, bMid: 0, bMax: 0 },
    //   4.1: { bMin: 0, bMid: 0, bMax: 0 },
    //   5: { bMin: 0, bMid: 0, bMax: 0 },
    //   6.2: { bMin: 0, bMid: 0, bMax: 0 }
    // },
    olympusTG4: {
      config: {
        stickMultiplierWarning: 3.4,
        stickMultiplierError: 4
      },
      4.5: {
        aMin: -0.00351,
        aMid: -0.00351,
        aMax: -0.00351,
        bMin: 0.00663,
        bMid: 0.00663,
        bMax: 0.00663,
        cMin: -0.00046,
        cMid: -0.00046,
        cMax: -0.00046
      },
      5.14: {
        aMin: -0.00583,
        aMid: -0.00583,
        aMax: -0.00583,
        bMin: 0.01414,
        bMid: 0.01414,
        bMax: 0.01414,
        cMin: -0.00935,
        cMid: -0.00935,
        cMax: -0.00935
      },
      5.5: {
        aMin: -0.00502,
        aMid: -0.00502,
        aMax: -0.00502,
        bMin: 0.01199,
        bMid: 0.01199,
        bMax: 0.01199,
        cMin: -0.00642,
        cMid: -0.00642,
        cMax: -0.00642
      },
      5.87: {
        aMin: -0.00404,
        aMid: -0.00404,
        aMax: -0.00404,
        bMin: 0.01055,
        bMid: 0.01055,
        bMax: 0.01055,
        cMin: -0.0058,
        cMid: -0.0058,
        cMax: -0.0058
      },
      6.42: {
        aMin: -0.00641,
        aMid: -0.00641,
        aMax: -0.00641,
        bMin: 0.0181,
        bMid: 0.0181,
        bMax: 0.0181,
        cMin: -0.01476,
        cMid: -0.01476,
        cMax: -0.01476
      },
      6.86: {
        aMin: -0.0024,
        aMid: -0.0024,
        aMax: -0.0024,
        bMin: 0.00592,
        bMid: 0.00592,
        bMax: 0.00592,
        cMin: -0.00236,
        cMid: -0.00236,
        cMax: -0.00236
      },
      7.34: {
        aMin: 0.00109,
        aMid: 0.00109,
        aMax: 0.00109,
        bMin: -0.00506,
        bMid: -0.00506,
        bMax: -0.00506,
        cMin: 0.009,
        cMid: 0.009,
        cMax: 0.009
      },
      7.86: {
        aMin: -0.00168,
        aMid: -0.00168,
        aMax: -0.00168,
        bMin: 0.00102,
        bMid: 0.00102,
        bMax: 0.00102,
        cMin: 0.00562,
        cMid: 0.00562,
        cMax: 0.00562
      },
      8.41: {
        aMin: -0.00056,
        aMid: -0.00056,
        aMax: -0.00056,
        bMin: -0.00036,
        bMid: -0.00036,
        bMax: -0.00036,
        cMin: 0.00433,
        cMid: 0.00433,
        cMax: 0.00433
      },
      8.99: {
        aMin: 0.00067,
        aMid: 0.00067,
        aMax: 0.00067,
        bMin: -0.00547,
        bMid: -0.00547,
        bMax: -0.00547,
        cMin: 0.01074,
        cMid: 0.01074,
        cMax: 0.01074
      },
      9.61: {
        aMin: -0.00284,
        aMid: -0.00284,
        aMax: -0.00284,
        bMin: 0.0067,
        bMid: 0.0067,
        bMax: 0.0067,
        cMin: -0.00243,
        cMid: -0.00243,
        cMax: -0.00243
      },
      10.29: {
        aMin: -0.00161,
        aMid: -0.00161,
        aMax: -0.00161,
        bMin: 0.00459,
        bMid: 0.00459,
        bMax: 0.00459,
        cMin: -0.00211,
        cMid: -0.00211,
        cMax: -0.00211
      },
      11.01: {
        aMin: -0.00837,
        aMid: -0.00837,
        aMax: -0.00837,
        bMin: 0.0231,
        bMid: 0.0231,
        bMax: 0.0231,
        cMin: -0.01675,
        cMid: -0.01675,
        cMax: -0.01675
      },
      11.78: {
        aMin: -0.00567,
        aMid: -0.00567,
        aMax: -0.00567,
        bMin: 0.01509,
        bMid: 0.01509,
        bMax: 0.01509,
        cMin: -0.01148,
        cMid: -0.01148,
        cMax: -0.01148
      },
      12.6: {
        aMin: -0.0044,
        aMid: -0.0044,
        aMax: -0.0044,
        bMin: 0.01191,
        bMid: 0.01191,
        bMax: 0.01191,
        cMin: -0.00896,
        cMid: -0.00896,
        cMax: -0.00896
      },
      13.47: {
        aMin: -0.00342,
        aMid: -0.00342,
        aMax: -0.00342,
        bMin: 0.00758,
        bMid: 0.00758,
        bMax: 0.00758,
        cMin: -0.00313,
        cMid: -0.00313,
        cMax: -0.00313
      },
      14.41: {
        aMin: -0.00535,
        aMid: -0.00535,
        aMax: -0.00535,
        bMin: 0.01388,
        bMid: 0.01388,
        bMax: 0.01388,
        cMin: -0.00983,
        cMid: -0.00983,
        cMax: -0.00983
      },
      15.41: {
        aMin: -0.00363,
        aMid: -0.00363,
        aMax: -0.00363,
        bMin: 0.01053,
        bMid: 0.01053,
        bMax: 0.01053,
        cMin: -0.00928,
        cMid: -0.00928,
        cMax: -0.00928
      },
      16.48: {
        aMin: -0.00562,
        aMid: -0.00562,
        aMax: -0.00562,
        bMin: 0.01609,
        bMid: 0.01609,
        bMax: 0.01609,
        cMin: -0.014,
        cMid: -0.014,
        cMax: -0.014
      },
      18: {
        aMin: -0.00662,
        aMid: -0.00662,
        aMax: -0.00662,
        bMin: 0.01957,
        bMid: 0.01957,
        bMax: 0.01957,
        cMin: -0.018,
        cMid: -0.018,
        cMax: -0.018
      }
    },
    // phones
    // iPhone_5s: {
    //   config: {
    //     stickMultiplierWarning: 3.4,
    //     stickMultiplierError: 4
    //   },
    //   4.15: { aMin: -0.021, aMid: -0.021, aMax: -0.021, bMin: 0.05, bMid: 0.05, bMax: 0.05, cMin: -0.021, cMid: -0.021, cMax: -0.021 }
    // },
    // tablets
    // iPad_mini_4: {
    //   config: {
    //     stickMultiplierWarning: 3.4,
    //     stickMultiplierError: 4
    //   },
    //   3.3: { bMin: 0.0168, bMid: 0.0168, bMax: 0.0168 }
    // },
    // galaxy_tab_s4: {
    //   config: {
    //     stickMultiplierWarning: 2.14,
    //     stickMultiplierError: 2.85
    //   },
    //   3.6: {
    //     aMin: 0.0103935,
    //     aMid: 0.0103935,
    //     aMax: 0.0103935,
    //     bMin: -0.04820667,
    //     bMid: -0.04820667,
    //     bMax: -0.04820667,
    //     cMin: 0.07073699,
    //     cMid: 0.07073699,
    //     cMax: 0.07073699
    //   }
    // },
    M50_18_155: {
      config: {
        stickMultiplierWarning: 3.4,
        stickMultiplierError: 4
      },
      18: { bMin: -0.02, bMid: -0.02, bMax: -0.02 },
      21: { bMin: -0.01625, bMid: -0.01625, bMax: -0.01625 },
      22: { bMin: -0.015, bMid: -0.015, bMax: -0.015 },
      24: { bMin: -0.003, bMid: -0.003, bMax: -0.003 },
      26: { bMin: -0.00115909090909091, bMid: 0.010125, bMax: 0.0009204545455 },
      26: { bMin: -0.001159090909, bMid: 0.010125, bMax: 0.0009204545455 },
      28: { bMin: 0.0006818181818, bMid: 0.010125, bMax: 0.0009204545455 },
      29: { bMin: 0.001602272727, bMid: 0.010125, bMax: 0.0009204545455 },
      30: { bMin: 0.002522727273, bMid: 0.010125, bMax: 0.0009204545455 },
      31: { bMin: 0.003443181818, bMid: 0.010125, bMax: 0.0009204545455 },
      32: { bMin: 0.004363636364, bMid: 0.010125, bMax: 0.0009204545455 },
      34: { bMin: 0.006204545455, bMid: 0.010125, bMax: 0.0009204545455 },
      35: { bMin: 0.007125, bMid: 0.007125, bMax: 0.007125 },
      37: { bMin: 0.007043478261, bMid: 0.001875, bMax: 0.00004076086957 },
      39: { bMin: 0.006961956522, bMid: 0.001875, bMax: 0.00004076086957 },
      40: { bMin: 0.006921195652, bMid: 0.001875, bMax: 0.00004076086957 },
      41: { bMin: 0.006880434783, bMid: 0.001875, bMax: 0.00004076086957 },
      43: { bMin: 0.006798913043, bMid: 0.001875, bMax: 0.00004076086957 },
      44: { bMin: 0.006758152174, bMid: 0.001875, bMax: 0.00004076086957 },
      45: { bMin: 0.006717391304, bMid: 0.001875, bMax: 0.00004076086957 },
      47: { bMin: 0.006635869565, bMid: 0.001875, bMax: 0.00004076086957 },
      48: { bMin: 0.006595108696, bMid: 0.001875, bMax: 0.00004076086957 },
      50: { bMin: 0.006513586957, bMid: 0.001875, bMax: 0.00004076086957 },
      52: { bMin: 0.006432065217, bMid: 0.001875, bMax: 0.00004076086957 },
      54: { bMin: 0.006350543478, bMid: 0.001875, bMax: 0.00004076086957 },
      56: { bMin: 0.006269021739, bMid: 0.001875, bMax: 0.00004076086957 },
      57: { bMin: 0.00622826087, bMid: 0.001875, bMax: 0.00004076086957 },
      59: { bMin: 0.00614673913, bMid: 0.001875, bMax: 0.00004076086957 },
      60: { bMin: 0.006105978261, bMid: 0.001875, bMax: 0.00004076086957 },
      62: { bMin: 0.006024456522, bMid: 0.001875, bMax: 0.00004076086957 },
      64: { bMin: 0.005942934783, bMid: 0.001875, bMax: 0.00004076086957 },
      66: { bMin: 0.005861413043, bMid: 0.001875, bMax: 0.00004076086957 },
      68: { bMin: 0.005779891304, bMid: 0.001875, bMax: 0.00004076086957 },
      70: { bMin: 0.005698369565, bMid: 0.001875, bMax: 0.00004076086957 },
      74: { bMin: 0.005535326087, bMid: 0.001875, bMax: 0.00004076086957 },
      76: { bMin: 0.005453804348, bMid: 0.001875, bMax: 0.00004076086957 },
      79: { bMin: 0.005331521739, bMid: 0.001875, bMax: 0.00004076086957 },
      81: { bMin: 0.00525, bMid: 0.00525, bMax: 0.00525 },
      84: { bMin: 0.00520923913, bMid: 0.00520923913, bMax: 0.00520923913 },
      86: { bMin: 0.005168478261, bMid: 0.005168478261, bMax: 0.005168478261 },
      89: { bMin: 0.005127717391, bMid: 0.005127717391, bMax: 0.005127717391 },
      92: { bMin: 0.005086956522, bMid: 0.005086956522, bMax: 0.005086956522 },
      95: { bMin: 0.005046195652, bMid: 0.005046195652, bMax: 0.005046195652 },
      100: { bMin: 0.005005434783, bMid: 0.005005434783, bMax: 0.005005434783 },
      105: { bMin: 0.004964673913, bMid: 0.004964673913, bMax: 0.004964673913 },
      111: { bMin: 0.004923913043, bMid: 0.004923913043, bMax: 0.004923913043 },
      115: { bMin: 0.004883152174, bMid: 0.004883152174, bMax: 0.004883152174 },
      118: { bMin: 0.004842391304, bMid: 0.004842391304, bMax: 0.004842391304 },
      122: { bMin: 0.004801630435, bMid: 0.004801630435, bMax: 0.004801630435 },
      125: { bMin: 0.004760869565, bMid: 0.004760869565, bMax: 0.004760869565 },
      129: { bMin: 0.004720108696, bMid: 0.004720108696, bMax: 0.004720108696 },
      132: { bMin: 0.004679347826, bMid: 0.004679347826, bMax: 0.004679347826 },
      135: { bMin: 0.004638586957, bMid: 0.004638586957, bMax: 0.004638586957 },
      138: { bMin: 0.004597826087, bMid: 0.004597826087, bMax: 0.004597826087 },
      141: { bMin: 0.004557065217, bMid: 0.004557065217, bMax: 0.004557065217 },
      150: { bMin: 0.004516304348, bMid: 0.004516304348, bMax: 0.004516304348 }
    },
    RF24_105: {
      config: {
        stickMultiplierWarning: 3.4,
        stickMultiplierError: 4
      },
      24: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      25: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      26: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      27: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      28: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      29: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      30: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      31: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      32: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      33: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      34: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      35: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      36: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      37: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      38: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      39: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      40: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      41: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      42: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      43: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      44: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      45: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      46: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      47: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      48: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      49: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      50: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      51: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      52: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      53: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      54: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      55: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      56: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      57: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      58: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      59: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      60: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      61: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      62: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      63: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      64: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      65: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      66: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      67: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      68: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      69: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      70: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      71: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      72: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      73: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      74: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      75: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      76: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      77: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      78: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      79: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      80: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      81: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      82: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      83: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      84: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      85: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      86: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      87: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      88: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      89: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      90: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      91: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      92: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      93: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      94: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      95: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      96: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      97: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      98: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      99: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      100: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      101: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      102: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      103: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      104: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 },
      105: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: -0.002, cMid: -0.002, cMax: -0.002 }
    },
    RF24_105L: {
      config: {
        stickMultiplierWarning: 3.4,
        stickMultiplierError: 4
      },
      24: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      25: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      26: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      27: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      28: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      29: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      30: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      31: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      32: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      33: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      34: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      35: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      36: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      37: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      38: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      39: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      40: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      41: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      42: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      43: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      44: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      45: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      46: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      47: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      48: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      49: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      50: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      51: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      52: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      53: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      54: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      55: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      56: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      57: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      58: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      59: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      60: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      61: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      62: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      63: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      64: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      65: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      66: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      67: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      68: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      69: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      70: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      71: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      72: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      73: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      74: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      75: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      76: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      77: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      78: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      79: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      80: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      81: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      82: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      83: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      84: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      85: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      86: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      87: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      88: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      89: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      90: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      91: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      92: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      93: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      94: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      95: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      96: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      97: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      98: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      99: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      100: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      101: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      102: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      103: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      104: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 },
      105: { aMin: 0, aMid: 0, aMax: 0, bMin: 0, bMid: 0, bMax: 0, cMin: 0.004, cMid: 0.004, cMax: 0.004 }
    },
    flat: {
      config: {
        stickMultiplierWarning: 3.4,
        stickMultiplierError: 4
      }
    }
    //iphone4s : {
    //		4.28    : {bMin:.005, bMid:.01, bMax:.007}
    //},
    //nexus4 : {
    //		4.6    : {bMin:-.005, bMid:-.012, bMax:-.025}
    //}

    /* list of cameras unable to calibrate:
           -- Canon T5i w/ EFS 18-55mm IS STM
           -- FujiFilm FinePix XP90
           -- Nikon Coolpix S33
      */

    /* list of phones unable to calibrate:
           -- MotoG3
      */

    /* list of tablets unable to calibrate:
           -- Nexus 9
      */
  }
};
